import * as form from '../form';

export const citizenshipPassports = (data = {}) => {
  const items = ((data.Passports || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        Country: form.country(xitem.Country),
        Issued: form.datecontrol(xitem.Issued),
        Location: form.location(xitem.Location),
        Name: form.name(xitem.Name),
        Number: form.text(xitem.Number),
        Expiration: form.datecontrol(xitem.Expiration),
        Used: form.branch(xitem.Used),
        Comments: form.textarea(xitem.Comments),
        UsedComments: form.textarea(xitem.UsedComments),
        CountriesComments: form.textarea(xitem.CountriesComments),
        Countries: form.collection(
          ((xitem.Countries || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Country: form.country(yitem.Country),
                Dates: form.daterange(yitem.Dates),
              },
            };
          })
        ),
      },
    };
  });
  return {
    Passports: form.collection(items),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
    HasPassportBook: form.branch(data.HasPassportBook), // Item and below PVQ Only
    PassportBooks: form.passports(data.PassportBooks).props,
    HasPassportBookExplanation: form.textarea(data.HasPassportBookExplanation),
    PassportCard: form.passport(data.PassportCard),
    HasPassportCard: form.branch(data.HasPassportCard),
    HasPassportCardExplanation: form.textarea(data.HasPassportCardExplanation),
  };
};
